import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../AuthContext";
import "../styles/Account.css";
import UserRegisterModal from "./UserRegisterModal";  
import UserEditModal from "./UserEditModal";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Account = () => {
    const { user, setUser } = useAuth();
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 10;
    const [isModalOpen, setIsModalOpen] = useState(false); // 모달 상태 관리
    //const [searchField, setSearchField] = useState("all");  // 라디오 버튼에서 선택된 항목
    const [searchField, setSearchField] = useState(user.userType === "P" ? "userName" : "all");  // 라디오 버튼에서 선택된 항목
    const [searchKeyword, setSearchKeyword] = useState(null);  // 검색 키워드
    const [selectedUser, setSelectedUser] = useState(null);
    //const [partnerCode, setPartnerCode] = useState("");

    const [plist, setPlist] = useState([]);
    const [glist, setGlist] = useState([]);
    const [LoginUserText, setLoginUserText] = useState("");

    const hasRun = useRef(false);

    const handleRowClick = (account) => {
        setSelectedUser(account);
    };
    
    const handleSaveUser = (updatedUser) => {
        setUsers(users.map((u) => (u.snum === updatedUser.snum ? updatedUser : u)));
    };

    const handleSearch = () => {
        fetchUsers(searchField, searchKeyword);  // 필터링된 값으로 다시 fetch 호출
    };

    const handleSearchFieldChange = (e) => {
        const selectedValue = e.target.value;
        setSearchField(e.target.value);  // 선택된 콤보박스 값 설정
        // "회원구분"을 선택하면 기본값 설정
        if (selectedValue === "userType") {
            setSearchKeyword("S"); // 기본값을 "S"로 설정 (빛담관리자)
        } else {
            setSearchKeyword(""); // 다른 경우 입력값 초기화
        }
    };

    const handleSearchKeywordChange = (e) => {
        setSearchKeyword(e.target.value);  // 검색어 값 설정
    };

    const handleUserTypeChange = (e) => {
        setSearchKeyword(e.target.value); // 선택한 값(S, P, G, U) 저장
    };

    // 파트너 코드 리스트 가져오기
    const getPartnerCode = async () => {

        try {
            const response = await fetch(`${API_BASE_URL}/api/Partner/get-list`);
            const data = await response.json();

            if (response.ok) {
                setPlist(data.plist);
                //console.log(data.plist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {
            alert("파트너 리스트 조회 중 오류가 발생했습니다.");
        }
    };

    // 파트너 코드 리스트 가져오기
    const getGovernmentCode = async () => {

        try {
            const response = await fetch(`${API_BASE_URL}/api/Government/get-list`);
            const data = await response.json();

            if (response.ok) {
                setGlist(data.glist);
                //console.log(data.glist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {
            alert("관공서 리스트 조회 중 오류가 발생했습니다.");
        }
    };

    // 기존의 fetchUsers 함수에 검색 필터 추가
    const fetchUsers = async (searchField, searchKeyword) => {

        // ✅ 조건 차단
        if (searchField === "userId" && searchKeyword === "") {
            alert("사용자ID를 입력해주세요");
            return; // ❗ fetch 중단
        }
        if (searchField === "userDate" && searchKeyword === "") {
            alert("등록일자 입력해주세요");
            return; // ❗ fetch 중단
        }
        if (searchField === "userName" && searchKeyword === "") {
            alert("사용자 이름을 입력해주세요");
            return; // ❗ fetch 중단
        }
        if (searchField === "userPhone" && searchKeyword === "") {
            alert("사용자 전화번호를 입력해주세요");
            return; // ❗ fetch 중단
        }
        if (searchField === "userEmail" && searchKeyword === "") {
            alert("사용자 이메일을 입력해주세요");
            return; // ❗ fetch 중단
        }
        if (searchField === "addressAll" && searchKeyword === "") {
            alert("사용자 주소를 입력해주세요");
            return; // ❗ fetch 중단
        }

        try {
    
            const queryParams = new URLSearchParams({
                page,
                pageSize,
                searchField,
                searchKeyword,                
                ...(user.partnerCode ? { partnerCode: user.partnerCode } : {}),
                ...(user.userType ? { loginUserType: user.userType } : {})
            });
            
            const response = await fetch(`${API_BASE_URL}/api/Account/get-users?${queryParams}`);
            const data = await response.json();
            //console.log(response);
            if (response.ok) {
                setUsers(data.users);
                setTotalPages(Math.ceil(data.totalRecords / pageSize));
            } else {
                console.log(data.message || "조회 실패");
            }
        } catch (error) {
            console.error("조회 실패:", error);
            alert("서버 오류 발생");
        }
    };

    useEffect(() => {
        if (searchField !== null && searchKeyword === null) {
            setSearchKeyword("");
        }
    }, [searchField]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); // 페이지 로드 시 실행

    useEffect(() => {
        if (hasRun.current) return; // 이미 실행되었으면 종료
        hasRun.current = true; // 첫 실행 후 플래그 설정

        getPartnerCode();
        getGovernmentCode();

    }, []);

    useEffect(() => {
        if (user.userType === "S") {

            setLoginUserText(`Admin > ${user.name}`);
        }
        else if (user.userType === "P" && plist.length > 0) {
            const selectedPartner = plist.find(p => p.partnerCode === user.partnerCode);
            const partnerName = selectedPartner?.partnerName ?? "알 수 없는 파트너";
            setLoginUserText(`${partnerName} > ${user.name}`);
        }
        else if (user.userType === "G" && glist.length > 0) {
            const selectedGovernment = glist.find(p => p.governmentCode === user.governmentCode);
            const governmentName = selectedGovernment?.governmentName ?? "알 수 없는 파트너";
            setLoginUserText(`${governmentName} > ${user.name}`);
        }
        else if (user.userType === "U") {

            setLoginUserText(`${user.userId}`);
        }
        else {
            setLoginUserText(`비 정상 로그인입니다.`);
        }
    }, [plist, glist]); // plist가 업데이트될 때 실행

    useEffect(() => {        
        fetchUsers(searchField, searchKeyword);
    }, [page]);

    useEffect(() => {
        const validTotalPages = totalPages > 0 ? totalPages : 1; // totalPages가 0 또는 null이면 1로 설정

        if (page > validTotalPages) {
            setPage(validTotalPages);  // 현재 선택된 페이지가 전체 페이지보다 크면 마지막 페이지로 이동
        }
    }, [totalPages]);  // totalPages가 변경될 때 실행

    // ✅ 사용자 추가 후 호출될 콜백 함수
    const handleUserAdded = () => {
        setSearchField("");
        setSearchKeyword("");
        fetchUsers(searchField, searchKeyword);  // 사용자 추가 후 다시 목록 로드
    };

    const handleAddUserClick = () => {
        setIsModalOpen(true); // 팝업 열기
    };

    const closePopup = () => {
        setIsModalOpen(false); // 팝업 닫기
    };

    const renderPagination = () => {
        if (totalPages <= 10) {
            return [...Array(totalPages)].map((_, index) => (
                <button
                    key={index + 1}
                    className={page === index + 1 ? "active" : ""}
                    onClick={() => setPage(index + 1)}
                >
                    [{index + 1}]
                </button>
            ));
        }
        let pages = [];
        if (page <= 6) {
            pages = [1, 2, 3, 4, 5, 6, 7, 8, 9, "...", totalPages];
        } else if (page >= totalPages - 5) {
            pages = [1, "...", totalPages - 8, totalPages - 7, totalPages - 6, totalPages - 5, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
        } else {
            pages = [1, "...", page - 3, page - 2, page - 1, page, page + 1, page + 2, page + 3, "...", totalPages];
        }

        return pages.map((p, index) => (
            <button
                key={index}
                className={page === p ? "active" : ""}
                onClick={() => typeof p === "number" && setPage(p)}
                disabled={typeof p !== "number"}
            >
                [{p}]
            </button>
        ));
    };

    return (
        <div className="account-wrapper">
            <div className="account-header">
                {/* <h1>사용자 관리 - {user.partnerCode}</h1> */}
                <h1>사용자관리 <span style={{ fontSize: "0.7em", color: "gray" }}>{LoginUserText}</span></h1>
                <button className="add-button" onClick={handleAddUserClick}>+</button> {/* + 버튼 */}                
            </div>
            <hr className="title-line" />
            
            {/* ✅ 모달 창 표시 (UserRegisterModal.js에 handleUserAdded 전달) */}
            {isModalOpen && <UserRegisterModal plist={plist} glist={glist} onClose={() => setIsModalOpen(false)} onUserAdded={handleUserAdded} />}

            {/* 검색 섹션 */}
            <div className="search-container">
                <label>                    
                    <select value={searchField} onChange={handleSearchFieldChange}>
                        <option value="all">전체조회</option>
                        <option value="userId">사용자ID</option>
                        <option value="userDate">등록일자</option>
                        {user.userType === "S" && <option value="userType">회원구분</option>}
                        <option value="userName">이름</option>
                        <option value="userPhone">전화번호</option>
                        <option value="userEmail">이메일</option>
                        <option value="addressAll">주소</option>
                        {user.userType === "S" && <option value="pCode">파트너코드</option>}
                        {user.userType === "S" && <option value="gCode">관공서코드</option>}
                        <option value="active">활성화</option>
                        <option value="deactive">비활성화</option>
                    </select>
                </label>
                
                {/* 검색어 입력 (전체조회, 활성화, 비활성화, 회원구분 제외) */}
                {searchField !== "all" && searchField !== "active" && searchField !== "deactive" && searchField !== "userType" && searchField !== "pCode" && searchField !== "gCode" && (
                    <label>
                    
                        <input
                            type="text"
                            value={searchKeyword}
                            onChange={handleSearchKeywordChange}
                            maxLength={18}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleSearch(); // 
                                }
                            }}
                        />
                    </label>
                )}
                {/* "회원구분" 선택 시 새로운 콤보박스 출력 */}
                {searchField === "userType" && (
                    <label>
                        <select value={searchKeyword} onChange={handleUserTypeChange}>
                            <option value="S">빛담관리자</option>
                            <option value="P">파트너</option>
                            <option value="G">관공서</option>
                            <option value="U">사용자</option>
                        </select>
                    </label>
                )}
                {searchField === "pCode" && (
                    <label>

                        <select value={searchKeyword} onChange={handleUserTypeChange}>
                            <option value="">선택된 파트너 없음</option> {/* 기본값 */}
                            {plist.map((partner) => (
                                <option key={partner.snum} value={partner.partnerCode}>
                                    {partner.snum}, {partner.partnerCode} : {partner.partnerName}
                                </option>
                            ))}
                        </select>

                    </label>
                )}
                {searchField === "gCode" && (
                    <label>

                        <select value={searchKeyword} onChange={handleUserTypeChange}>
                            <option value="">선택된 관공서 없음</option> {/* 기본값 */}
                            {glist.map((government) => (
                                <option key={government.snum} value={government.governmentCode}>
                                    {government.snum}, {government.governmentCode} : {government.governmentName}
                                </option>
                            ))}
                        </select>

                    </label>
                )}
                <button onClick={handleSearch}>검색</button>
            </div>
                

            <div className="account-container">
                <ul className="account-list">

                    <li className="account-header-row">
                        <span className="snum">순번</span>
                        <span className="userID">사용자ID</span>
                        <span className="userDate">등록일자</span>
                        {user.userType === "S" && <span className="userType">회원구분</span>}
                        <span className="userName">이름</span>
                        <span className="userPhone">전화번호</span>
                        <span className="userEmail">이메일</span>
                        <span className="userActive">활성화</span>
                    </li>


                    <hr className="thick-line" />

                    {users.map((account, index) => (
                        <React.Fragment key={account.snum}>
                            <li className="account-row" onClick={() => handleRowClick(account)}>
                                <span className="snum" style={{ color: account.isActive === "T" ? "white" : "gray" }}>{account.snum}</span>                                
                                <span className="userID" style={{ color: account.isActive === "T" ? "white" : "gray" }}>{account.userId}</span>
                                <span className="userDate" style={{ color: account.isActive === "T" ? "white" : "gray" }}>{account.userDate}</span>
                                {user.userType === "S" && (
                                    <span className="userType"
                                        style={{
                                            color: account.isActive === "T" ? { 
                                                S: "#6699FF",   // 빛담관리자 (빨강)
                                                P: "#FFEE99",  // 파트너 (파랑)
                                                G: "#2ECC71", // 관공서 (초록)
                                                U: "#F0F0F0", // 사용자 (하얀색)
                                            }[account?.userType] || "gray" : "gray",
                                        }}
                                    >
                                        {{
                                            S: "빛담관리자",
                                            P: "파트너",
                                            G: "관공서",
                                            U: "사용자",
                                        }[account?.userType] || account?.userType}
                                    </span>
                                )}
                                <span className="userName" style={{ color: account.isActive === "T" ? "white" : "gray" }}>{account.name}</span>
                                <span className="userPhone" style={{ color: account.isActive === "T" ? "white" : "gray" }}>{account.phone}</span>
                                <span className="userEmail" style={{ color: account.isActive === "T" ? "white" : "gray" }}>{account.email}</span>
                                
                                <span className="userActive" style={{ color: account.isActive === "T" ? "white" : "red" }}>
                                    {account.isActive === "T" ? "✔" : "✖"}
                                </span>

                            </li>
                            <hr className="thin-line" />
                        </React.Fragment>
                    ))}
                    {selectedUser && <UserEditModal selectedUser={selectedUser} plist={plist} glist={glist} onClose={() => setSelectedUser(null)} onSave={handleSaveUser} onUserAdded={handleUserAdded} />}
                    <hr className="thick-line" />
                </ul>
                <div className="pagination">{renderPagination()}</div>
            </div>
        </div>
    );
};

export default Account;
